import React from "react"
import { useHistory, useLocation } from "react-router-dom"
import queryString from "query-string"
import styles from "./index.module.scss"
import XYCenterAlignedWindow from "../../components/XYCenterAlignedWindow"
import Button from "../../components/Button/Button"
import { paths } from "../../routes/paths"

const AdminConfirmationPage = () => {
  const history = useHistory()
  const location = useLocation()
  const queryParams = queryString.parse(location.search)
  const companyName = queryParams.company || "Broadway Capital"

  return (
    <div className={styles.pageWrap}>
      <XYCenterAlignedWindow>
        <div className={styles.confirmationContent}>
          <h1 className={styles.title}>New Admin Confirmed</h1>
          <p className={styles.description}>
            You have administrative privileges for the {companyName} account. Click the sign in button below to access your profile page.
          </p>
          <div className={styles.buttonWrapper}>
            <Button
              onClick={() => history.push(paths.login)}
              buttonStyle="contained"
              width="137px"
              height="48px"
            >
              Sign in
            </Button>
          </div>
        </div>
      </XYCenterAlignedWindow>
    </div>
  )
}

export default AdminConfirmationPage

